// src/components/PurchaseSlotModal.js

import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
import axios from 'axios';

const PurchaseSlotModal = ({
  open,
  onClose,
  accessToken,
  selectedGuild,
  fetchSubscriptionData,
  setSnackbar,
  maxCollectionsAllowed,
}) => {
  const [slotsToPurchase, setSlotsToPurchase] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isPaymentProcessed, setIsPaymentProcessed] = useState(false);

  const handlePurchaseSlotPayment = async () => {
    setLoading(true);
    // Simulate payment processing
    setTimeout(async () => {
      const simulatedHash = `simulatedHash_${Date.now()}`;

      try {
        // Call backend API to purchase additional slots
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/server-config/${selectedGuild}/purchase-collection-slot`,
          {
            paymentHash: simulatedHash,
            slotsToPurchase,
          },
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );

        // Fetch updated subscription data
        await fetchSubscriptionData();

        setIsPaymentProcessed(true);
        setLoading(false);

        setSnackbar({
          open: true,
          message: `Successfully purchased ${slotsToPurchase} additional collection slot(s)!`,
          severity: 'success',
        });
      } catch (error) {
        console.error('Error purchasing collection slot:', error);
        const errorMsg = error.response?.data?.error || error.message;
        setSnackbar({
          open: true,
          message: `Failed to purchase collection slot: ${errorMsg}`,
          severity: 'error',
        });
        setLoading(false);
      }
    }, 2000); // Simulate 2 seconds payment processing
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle
        sx={{
          color: '#E0E4ED',
          backgroundColor: '#040813',
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        Purchase Additional Collection Slot
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: '#0D1F3A',
          padding: 3,
        }}
      >
        <Typography sx={{ color: '#E0E4ED', mb: 2 }}>
          You have reached the maximum number of collections ({maxCollectionsAllowed}).
          To add more collections, please purchase additional slots.
        </Typography>
        {!isPaymentProcessed ? (
          <>
            <TextField
              label="Number of Slots"
              type="number"
              value={slotsToPurchase}
              onChange={(e) => setSlotsToPurchase(Number(e.target.value))}
              InputProps={{ inputProps: { min: 1 } }}
              fullWidth
              sx={{
                mt: 2,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#607080',
                  },
                  '&:hover fieldset': {
                    borderColor: '#9AC0CD',
                  },
                },
              }}
              InputLabelProps={{
                style: {
                  color: '#D1E5F0',
                },
              }}
            />
            <Button
              variant="contained"
              onClick={handlePurchaseSlotPayment}
              disabled={loading}
              sx={{
                mt: 2,
                backgroundColor: '#728C63',
                color: '#FFFFFF',
                '&:hover': {
                  backgroundColor: '#8BA675',
                },
              }}
              fullWidth
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                `Pay ${(0.5 * slotsToPurchase).toFixed(2)} SOL`
              )}
            </Button>
          </>
        ) : (
          <Typography sx={{ mt: 2, color: '#E0E4ED' }}>
            Payment successful! You can now add additional collections.
          </Typography>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: '#040813',
          padding: 2,
        }}
      >
        <Button
          onClick={() => {
            setIsPaymentProcessed(false);
            setSlotsToPurchase(1);
            onClose();
          }}
          sx={{
            color: '#A1D1F0',
            borderColor: '#4C5C64',
            textTransform: 'none',
            '&:hover': {
              borderColor: '#9AC0CD',
              backgroundColor: 'rgba(154, 192, 205, 0.1)',
            },
          }}
          variant="outlined"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PurchaseSlotModal;

